import * as React from 'react';

export const ArrowDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 10 10" {...props}>
    <path
      fill="currentColor"
      d="M8.18106781 2.7 8.88817459 3.40710678 4.9990873 7.29619408 1.11 3.40710678 1.81710678 2.7 4.9990873 5.88198052z"
    />
  </svg>
);
